import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import AudioPlayer from "../../QuestionPage/AudioPlayer";
import FillInTheBlanksInput from "../../QuestionPage/FillInTheBlanksInput";
// Fetching Data from the API]

// End

// Page Html
export default function FillInTheBlanksMockPage({ question ,questionNumber,maxQuestion }) {
  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };

  const [Options, setOptions] = useState([]);

  const [originalWords, setOriginalWords] = useState("");
  const [Title, setTitle] = useState("");
  const [Mcq_Question, setMcq_Question] = useState("");
  const [McqOptions, setMcqOptions] = useState("");
  const [submittedOptions, setSubmittedOptions] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [userInput, setUserInput] = useState([]);
  const [isAttempted, setIsAttempted] = useState(false);



  const [audioLink, setAudioLink] = useState("");
  const audioRef = useRef(null);

  useEffect(() => {
    setAudioLink(question.media_link);
    setOriginalWords(question.question);
    setMcqOptions(question.option);
    setMcq_Question(question.question_mcq);
    resetAudio();
  }, [question]);

  const resetAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };
  const handleRetake = () => {
    setSubmitted(false);
    setIsAttempted(false);
    setSubmittedOptions([]);
  };

  const handleIsAttempted = (isAttemptedValue) => {
    setIsAttempted(isAttemptedValue);
  };


  const handleUserInput = (userInput) => {
    setUserInput(userInput); // Update state with user input
    console.log("User Input:", userInput); // Optional: Log user input for debugging or further processing
  };

  // useEffect to monitor userInput changes
  useEffect(() => {
    console.log("User Input updated:", userInput); // Log whenever userInput changes    
  }, [userInput]);



  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h3 className="text-lg  pt-3 font-bold text-gray-900 sm:text-2xl ml-1 text-center md:text-start">
          Mock Test
        </h3>
        <h2 className=" absolute  text-1xl font-bold right-10 top-10">
          {" "}
        </h2>
        <h2 className=" absolute  text-sm font-semibold text-gray-700 right-10 top-13">
          {" "}
          Question {questionNumber} of {maxQuestion}
        </h2>
        <p className="p-2">
          You will hear a sentence. Please repeat the sentence exactly as you
          hear it. You will hear the sentence only once.
        </p>
        {audioLink && <AudioPlayer audioSrc={audioLink} audioRef={audioRef} />}

        {/* <div className="font-bold p-2 pt-4 ml-[1000px] ">Time left:9.22 </div> */}
        <FillInTheBlanksInput
          sentence={originalWords}
          options={Options}
          submitted={submitted}
          onSubmit={handleUserInput} // Pass callback function to receive userInput
          onRetake={handleRetake}
          onIsAttempted={handleIsAttempted}
        />      </div>
    </div>
  );
}
